var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.35 45.227a8.488 8.488 0 0 1 0-16.977h5.115a.566.566 0 0 0 .543-.566v-5.659a5.66 5.66 0 0 0-5.659-5.658H8.87a5.682 5.682 0 0 0-5.659 5.659v29.426a5.682 5.682 0 0 0 5.659 5.659h38.48a5.659 5.659 0 0 0 5.66-5.66v-5.658a.566.566 0 0 0-.544-.566H47.35Z",
    fill: "#4287CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.14 31.646h-6.79a5.093 5.093 0 1 0 0 10.186h6.79a3.418 3.418 0 0 0 2.852-3.396v-3.395a3.418 3.418 0 0 0-2.852-3.395ZM47.78 6.022a2.738 2.738 0 0 0-1.268-1.72 2.807 2.807 0 0 0-2.128-.294l-29.132 7.854a.543.543 0 0 0-.408.543.566.566 0 0 0 .544.498H48.82a.545.545 0 0 0 .43-.226.52.52 0 0 0 .113-.272l-1.585-6.383Z",
    fill: "#4287CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalWalletIcon);
export default __webpack_public_path__ + "static/media/digital-wallet-icon.3c6599870a54855a1d52d9ae4bb42061.svg";
export { ForwardRef as ReactComponent };